module.exports = __webpack_public_path__ + "static/img/98.9d77dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/98.png
// module id = 6UqT
// module chunks = 0